import React from 'react';
import { QRCode } from 'react-qrcode-logo';

export default ({ logoImage, logoHeight, logoWidth, logoOpacity, value, size, qrStyle }) => {
  return <QRCode
    value={value}
    logoImage={logoImage}
    logoWidth={logoWidth}
    logoHeight={logoHeight}
    logoOpacity={logoOpacity}
    size={size}
    qrStyle={qrStyle} />
}
